<template>
  <div>
    <p class="toast-text">
      {{ props.message }}
    </p>
  </div>
</template>

<script setup>
const user = useUserStore()
const audioStore = useAudioStore()

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'default',
    required: false,
  },
  isGlobal: {
    type: Boolean,
    default: true,
  },

  audioKey: {
    type: String,
    default: null,
  },
})

onMounted(() => {
  if (props.isGlobal) {
    switch (props.type) {
      case 'error':
        audioStore.playSound('globalError')
        break
      case 'success':
        audioStore.playSound('globalSuccess')
        break
    }
  } else if (props.audioKey) {
    switch (props.audioKey) {
      case 'noInventory':
        audioStore.playSound('noInventory')
        break
      case 'successShopPurchase':
        audioStore.playSound('successPurchase')
        break
      default:
        audioStore.play(props.audioKey)
    }
  }
})
</script>

<style scss scoped>
.toast-text {
  font-weight: bold;
  color: white;
  font-size: 14px;
  font-family: quicksand-font;
}
</style>
